import { motion } from "framer-motion";

const steps = [
  { n: "01", label: "Assess", detail: "Meet the dog, the household, the pattern." },
  { n: "02", label: "Understand", detail: "Read the drive, the trigger, the leverage." },
  { n: "03", label: "Lead", detail: "Establish structure and calm authority." },
  { n: "04", label: "Train", detail: "Precision commands, off-leash discipline." },
  { n: "05", label: "Transform", detail: "A new relationship — dog and human alike." },
];

export default function Method() {
  return (
    <section className="section bg-ink-2 relative overflow-hidden" data-testid="method-section">
      <div className="blob" style={{ width: 600, height: 600, top: "20%", left: "-200px", background: "radial-gradient(circle, rgba(15,93,58,0.2), transparent 70%)" }} />
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-8 mb-16">
          <div className="md:col-span-4">
            <div className="text-eyebrow text-gold">02 / The Wolfkeeper Method</div>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-[clamp(2.4rem,6vw,6rem)] leading-[0.95] tracking-[-0.02em]">
              The dog is rarely the <span className="italic gold-foil">only student.</span>
            </h2>
            <p className="mt-6 max-w-2xl text-bone/75 text-lg font-editorial">
              Toriano's approach combines canine psychology, human behavior, leadership, lifestyle training, communication, structure, exercise, accountability and relationship building.
            </p>
          </div>
        </div>

        {/* Framework */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-16">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.08 * i }}
              className="relative border border-hair p-6 bg-ink"
              data-testid={`method-step-${i}`}
            >
              <div className="text-hair text-gold mb-3">{s.n}</div>
              <div className="font-display italic text-2xl md:text-3xl gold-foil">{s.label}</div>
              <p className="mt-3 text-sm text-bone/65">{s.detail}</p>
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute -right-2 top-1/2 -translate-y-1/2 text-gold text-2xl">→</div>
              )}
            </motion.div>
          ))}
        </div>

        <motion.blockquote
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="max-w-3xl border-l-2 border-gold pl-6"
        >
          <p className="font-display italic text-2xl md:text-3xl text-bone leading-snug">
            "I do not simply teach commands. I transform the relationship between the dog and the human."
          </p>
          <div className="text-hair text-bone/50 mt-4">— Toriano Sanzone</div>
        </motion.blockquote>
      </div>
    </section>
  );
}
